import React, { useEffect, useState } from "react";
import styles from "./AgentCardDetail.module.css";
import Tooltip from "../../TooltipSteps/Tooltip";
import Modal2 from "../../Modal2/Modal2";
import PublicCopyUrl from "../../PublicCopyUrl/PublicCopyUrl";
import Divider from "../../Divider/Divider";
import { useLocation, useNavigate } from "react-router-dom";
import decodeToken from "../../../lib/decodeToken";
import { getAppointments } from "../../../Store/apiStore";
import PopUp from "../../Popup/Popup";
import useAgentPermissions from "../../../hooks/useAgentPermissions";
import LockOverlay from "../../LockOverlay/LockOverlay";
import detectPlatform from "../../../utils/detectPlatform";
import { isMobileAppSurface } from "../../../contexts/GlobalCallContext";
// comment COMMENT
const AgentCardDetail = ({
  agentData,
  onTestCall,
  onAssignNumber,
  isRefresh,
  // QR-I467: Law Firm agent without Google Drive → calls/widget stay locked.
  driveLocked = false,
  driveLockMessage = "Connect Google Drive to use this.",
}) => {
  // console.log(agentData, "agentData")
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("token") || "";
  const decodeTokenData = decodeToken(token);
  const userIdFromToken = decodeTokenData?.id || "";
  // Live permission sync — resolved for the SELECTED agent's owner (multi-owner).
  // A member may be admin for one owner and view-only for another.
  const selectedOwnerId =
    (typeof window !== "undefined" &&
      (sessionStorage.getItem("SelectAgentOwnerId") ||
        localStorage.getItem("teamOwnerId"))) ||
    undefined;
  const { isTeamMember, isAdmin, canEditAgents, canViewCallLogs, canViewAppointments } =
    useAgentPermissions(selectedOwnerId);

  // Public Agent URL is a paid feature on the app surface (now web too): blur +
  // lock it when the agent is on a FREE (non-paid) plan.
  const _isMobile = isMobileAppSurface();
  const _planLower = String(agentData?.agent?.agentPlan || "").trim().toLowerCase();
  // "appsumo" counts as paid: the lifetime deal was bought on AppSumo's
  // checkout rather than ours, so the account has paid even though no
  // subscription of ours exists. Without it the mobile gate below would lock a
  // paying customer out of their own public URL until they assign a number.
  const _isPaidPlan = ["starter", "scaler", "growth", "payg", "pay-as-you-go", "appsumo"].includes(_planLower);
  /*
   * NUMBER ASSIGN ho chuka hai to lock nahi.
   *
   * Pehle gate sirf plan dekhta tha. A/B variant B me user ko number PAYMENT SE
   * PEHLE milta hai (/receptionist-number pe), to plan "free" rehte hue bhi uske
   * paas asli business number hota hai — aur public URL pe taala dikhta tha, jo
   * galat hai: number hai to wo apna agent publish kar hi sakta hai.
   *
   * Yahi shart FooterNew ke Public Agent / Widget Install gate me bhi hai.
   * A flow pe koi asar nahi — wahan number milta hi payment ke baad hai.
   */
  const _hasAssignedNumber = (() => {
    const v = agentData?.agent?.voip_numbers;
    if (!v) return false;
    if (Array.isArray(v)) return !!v[0];
    if (typeof v === "string") {
      const t = v.trim();
      if (!t || t === "[]" || t === "null") return false;
      if (t.startsWith("[")) {
        try {
          const parsed = JSON.parse(t);
          return Array.isArray(parsed) ? !!parsed[0] : !!parsed;
        } catch {
          return true;
        }
      }
      return true;
    }
    return false;
  })();
  const lockPublicUrl = _isMobile && !_isPaidPlan && !_hasAssignedNumber;
  // Public Agent URL is locked if EITHER gate applies: the Drive gate (Law Firm
  // agent without Google Drive) OR the mobile-free-plan upgrade gate. driveLocked
  // takes priority for the message shown.
  const publicUrlLocked = driveLocked || lockPublicUrl;
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("success");
  const [isVisible, setIsVisible] = useState(true);
  const [copied, setCopied] = useState(false);
  const [openPublicUrlModal, setOpenPublicUrlModal] = useState(false);
  const [publicUrlEditMode, setPublicUrlEditMode] = useState(false);
  // Appointments/call-logs owner ke account pe hote hain, member ke apne pe nahi
  // — wahi chain jo parent FastAgentDetails use karta hai.
  const userId = selectedOwnerId || userIdFromToken;
  const [refresh, setRefresh] = useState(false);
  const [meetingCount, setMeetingCount] = useState(0);
  const [agentDetails, setAgentDetail] = useState({
    agentId: sessionStorage.getItem("SelectAgentId"),
    bussinesId: sessionStorage.getItem("SelectAgentBusinessId"),
    agentDetails: location?.state?.agentDetails,
  });
  // sessionStorage wali id sirf mount pe padhi jaati hai — loaded agent ko prefer karo.
  const resolvedAgentId = agentData?.agent?.agent_id || agentDetails.agentId || null;
  useEffect(() => {
    // Locked tile ka data fetch mat karo — permissions async load hote hain, aur
    // beech me ek pal ke liye count dikh jaata tha.
    if (!userId || !canViewAppointments) {
      setMeetingCount(0);
      return;
    }
    let cancelled = false;
    const fetchMeetingCount = async () => {
      try {
        const res = await getAppointments(userId, resolvedAgentId);
        const list = Array.isArray(res?.data) ? res.data : [];
        if (!cancelled) setMeetingCount(list.length);
      } catch (e) {
        console.error("DB appointments error:", e);
        if (!cancelled) setMeetingCount(0);
      }
    };

    fetchMeetingCount();
    return () => {
      cancelled = true;
    };
    // isRefresh yahan dep nahi hai — wo parent ka inline callback hai, har render
    // pe nayi identity banti hai aur effect har baar dobara chal jaata.
  }, [userId, resolvedAgentId, canViewAppointments]);
  if (!isVisible) return null;

  const agent = agentData?.agent;
  const business = agentData?.business;

  // const agentName = agent?.agentName || "NA";
  const agentNameTooltip = agent?.agentName || "NA";
  const agentName =
    agent?.agentName && agent.agentName.length > 8
      ? agent.agentName.slice(0, 8) + "..."
      : agent?.agentName || "NA";
  const avatar = agent?.avatar || "/images/agent_dp.png";
  const language = agent?.agentLanguage || "English";
  const agentPlan = agent?.agentPlan;
  const businessName =
    business?.businessName ||
    business?.googleBusinessName ||
    agentData?.knowledge_base_texts?.name ||
    "NA";

  const formatE164USNumber = (number) => {
    if (!number) return "";
    const cleaned = String(number).replace(/\D/g, "");

    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      const country = cleaned[0];
      const area = cleaned.slice(1, 4);
      const prefix = cleaned.slice(4, 7);
      const line = cleaned.slice(7, 11);
      return `+${country} (${area}) ${prefix}-${line}`;
    }
    return number;
  };

  const getVoipNumbers = (v) => {
    if (!v) return [];
    if (Array.isArray(v)) return v.filter(Boolean);

    if (typeof v === "string") {
      try {
        const parsed = JSON.parse(v);
        return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
      } catch {
        return v.trim() ? [v.trim()] : [];
      }
    }
    return [];
  };

  const voipNumbersArr = getVoipNumbers(agent?.voip_numbers);
  const hasVoipNumbers = voipNumbersArr.length > 0;

  const getShortBusinessName = (name) => {
    if (!name) return "NA";
    const beforeDash = String(name).split(/[-–—]/)[0].trim();
    if (beforeDash) return beforeDash;
    return String(name).trim().split(/\s+/)[0] || "NA";
  };

  const shortBusinessName = getShortBusinessName(businessName);

  const handleCopyPublicLink = (agentCode, key) => {
    setPublicUrlEditMode(key);
    setOpenPublicUrlModal(true);
  };

  const defaultPublicUrl = `${process.env.REACT_APP_PUBLIC_WIDGET_DOMAIN}/${agentData?.agent?.ventryUrl}`;
  const ventryPublicUrl = agentData?.agent?.ventryUrl
    ? `${process.env.REACT_APP_PUBLIC_WIDGET_DOMAIN}/${agentData?.agent?.ventryUrl}`
    : null;

  const finalUrl = ventryPublicUrl || defaultPublicUrl;

  const handleCopy = () => {
    navigator.clipboard.writeText(finalUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleClosePublicWidget = () => {
    setOpenPublicUrlModal(false);
  };

  const handleCallHistoryNavigation = () => {
    sessionStorage.setItem("agentId", agentDetails?.agentId);
    sessionStorage.setItem("userId", userId);
    navigate("/totalcall-list?filter=callHistory");
    localStorage.setItem("filterType", "single");
  };
  const handleInactiveAgentAlert = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setPopupType("failed");
    setPopupMessage(
      "Your agent is not active. Please activate your agent first.",
    );
  };
  const handleCallTransfer = () => {
    if (agentData) {
      sessionStorage.setItem("agentDetails", JSON.stringify(agentData));
      const agentGeneralTools = agentData.generalTools;
      sessionStorage.setItem(
        "agentGeneralTools",
        JSON.stringify(agentGeneralTools),
      );
      navigate("/call-transfer");
    }
  };

  const hasCalendarId = Boolean(agent?.calendarId);
  const hasWeidget = Boolean(agent?.widgetScript);

  if (!agent) {
    return (
      <div className={styles.mainContainer}>
        <div className={styles.agentCard} style={{ opacity: 0.9 }}>
          <div className={styles.profileCard}>
            <div className={`${styles.AgentImg} ${styles.shimmer}`} />
            <div className={`${styles.language} ${styles.shimmer}`} style={{ width: 45, height: 16 }} />
          </div>
          <div className={styles.agentDetails} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div className={styles.shimmer} style={{ width: "55%", height: 22, borderRadius: 6 }} />
            <div className={styles.shimmer} style={{ width: "40%", height: 14, borderRadius: 4 }} />
            <div className={styles.shimmer} style={{ width: "70%", height: 18, borderRadius: 6, marginTop: 4 }} />
          </div>
        </div>

        <div className={styles.BottomAgentCard}>
          <div className={styles.InnerAgentCard2}>
            <div className={styles.TesDiv}><div className={styles.shimmer} style={{ width: "60%", height: 32, borderRadius: 6 }} /></div>
            <div className={styles.TesDiv}><div className={styles.shimmer} style={{ width: "60%", height: 32, borderRadius: 6 }} /></div>
            <div className={styles.TesDiv}><div className={styles.shimmer} style={{ width: "60%", height: 32, borderRadius: 6 }} /></div>
          </div>
        </div>

        <div className={styles.statsContainer} style={{ marginTop: 24 }}>
          <div className={`${styles.stat} ${styles.Yellow} ${styles.shimmer}`} style={{ height: 90 }} />
          <div className={`${styles.stat} ${styles.blue} ${styles.shimmer}`} style={{ height: 90 }} />
          <div className={`${styles.stat} ${styles.Purple} ${styles.shimmer}`} style={{ height: 90 }} />
          <div className={`${styles.stat} ${styles.Red} ${styles.shimmer}`} style={{ height: 90 }} />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={styles.agentCard}>
        <div className={styles.profileCard}>
          <div className={styles.AgentImg}>
            <img src={avatar} alt="agent_dp" />
          </div>
          <p className={styles.language}>{language}</p>
        </div>

        <div className={styles.agentDetails}>
          {/* The plan badge names the subscription the agent runs on — FREE,
              STARTER, and so on. "appsumo" is not a plan the customer chose or
              recognises; it is the internal marker that routes their credit
              pools, so it is hidden here while staying in the database for
              billing and the gates that read it. */}
          {_planLower !== "appsumo" && (
            <div className={styles.planStatus}>
              <p>{agentPlan}</p>
            </div>
          )}

          <div className={styles.AgentCardDetailMain}>
            <div className={styles.statusDetails}>
              <div>
                <h4 className={styles.AgentName} title={agentNameTooltip}>
                  {agentName}
                </h4>
              </div>

              {/* {hasVoipNumbers ? (
                                <>
                                    <div className={styles.liveDot} />
                                    <div className={styles.activeStatus1}>
                                        <p>Live</p>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div className={styles.status}></div>
                                    <div className={styles.activeStatus}>
                                        <p>Ready (not live)</p>
                                    </div>
                                </>
                            )} */}
              {/*
                              Optional-chain on agent — during a brief
                              render window (e.g. agentData still loading,
                              user lands here with 0 agents, etc.) `agent`
                              can be undefined. The non-optional access
                              that used to live here crashed the whole
                              page; the same bug shows up on Dashboard
                              too per user report. Defensive access lets
                              the surrounding loading / draft UI handle
                              the no-agent case instead of throwing.
                            */}
              {agent?.isDeactivated == 1 ? (
                <>
                  <div className={styles.status}></div>
                  <div className={styles.activeStatus}>
                    <p>Inactive</p>
                  </div>
                </>
              ) : hasVoipNumbers ? (
                <>
                  <div className={styles.liveDot} />
                  <div className={styles.activeStatus1}>
                    <p>Live</p>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.status}></div>
                  <div className={styles.activeStatus}>
                    <p>Ready (not live)</p>
                  </div>
                </>
              )}
            </div>

            <LockOverlay locked={!canEditAgents}>
              <div
                className={styles.editDiv}
                id="tour-edit-agent"
                onClick={() => {
                  sessionStorage.setItem("naviateFrom", "editAgent");
                  sessionStorage.setItem(
                    "SelectAgentBusinessId",
                    agentData?.agent?.businessId,
                  );
                  sessionStorage.setItem(
                    "SelectAgentId",
                    agentData?.agent?.agent_id,
                  );
                  navigate("/edit-name-avtar", {
                    state: {
                      agentId: agentData?.agent?.agent_id,
                      businessId: agentData?.agent?.businessId,
                    },
                  });
                }}
              >
                <img src="/svg/edit-icon3.svg" alt="edit_icon" />
              </div>
            </LockOverlay>
          </div>

          {/* short name + tooltip full name */}
          <div className={styles.bussinesName}>
            <p title={businessName}>{shortBusinessName}</p>
          </div>

          <div className={styles.Divider}></div>

          {!hasVoipNumbers ? (
            <div className={styles.NotNumberAssign}>
              <p className={styles.numberTitle}>AI Agent Phone Number</p>
              <div className={styles.notAssign}>
                <p className={styles.Ptext}>Not assigned yet</p>
                <Tooltip content="Share this number with customers or forward calls to it." />
              </div>
            </div>
          ) : (
            <div className={styles.YesNumberAssign}>
              <p className={styles.YesnumberTitle}>AI Agent Phone Number</p>
              <div className={styles.YesAssign}>
                <p className={styles.Ptext}>
                  {voipNumbersArr.map(formatE164USNumber).join(", ")}
                </p>
                <Tooltip content="Share this number with customers or forward calls to it. Share this number with customers or forward calls to it." />
              </div>
            </div>
          )}
        </div>
      </div>
      {!hasVoipNumbers ? (
        <div className={styles.BottomAgentCard}>
          <div className={styles.InnerAgentCard}>
            <LockOverlay locked={driveLocked} message={driveLockMessage}>
              <div
                className={styles.TesDiv}
                // onClick={onTestCall}
                onClick={(e) => {
                  e.stopPropagation();
                  if (agent?.isDeactivated == 1) {
                    handleInactiveAgentAlert(e);
                  } else {
                    onTestCall?.();
                  }
                }}
                style={{ cursor: "pointer" }}
                role="button"
                tabIndex={0}
                onKeyDown={(e) =>
                  (e.key === "Enter" || e.key === " ") && onTestCall?.()
                }
              >
                <img src="/svg/agent-call.svg" alt="agent-call" />
                <p className={styles.TextTest1}>Test Agent Call</p>
              </div>
            </LockOverlay>

            <LockOverlay
              locked={isTeamMember && !isAdmin}
              message="Only the account owner can assign a phone number."
            >
              <div
                className={styles.NumberButton}
                onClick={() => onAssignNumber?.()}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") onAssignNumber?.();
                }}
              >
                <p>Assign Phone Number</p>
              </div>
            </LockOverlay>
          </div>
        </div>
      ) : (
        <div className={styles.BottomAgentCard}>
          <LockOverlay locked={!canEditAgents} style={{ width: "100%" }}>
            <div className={styles.InnerAgentCard2}>
              <div
                className={styles.TesDiv}
                id="tour-call-routing"
                onClick={handleCallTransfer}
                style={{ cursor: "pointer" }}
              >
                <img src="/svg/agent-call.svg" alt="agent-call" />
                <p className={styles.TextTest}>Call Routing</p>
              </div>
              {hasCalendarId ? (
                <div
                  className={styles.TesDiv}
                  onClick={() => {
                    navigate("/add-file", {
                      state: {
                        agent_id: agentData?.agent?.agent_id,
                        knowledgeBaseId: agentData?.agent?.knowledgeBaseId,
                      },
                    });
                  }}
                  style={{ cursor: "pointer" }}
                  role="button"
                  tabIndex={0}
                >
                  <img
                    src="/svg/knowledge_base_icon.svg"
                    alt="knowledge_base"
                  />
                  <p className={styles.TextTest}>Knowledge Base</p>
                </div>
              ) : (
                <div
                  className={styles.TesDiv}
                  id="tour-connect-calendar"
                  onClick={() =>
                    // Name this card's agent explicitly — the screen must not
                    // guess it from whichever agent was opened last.
                    navigate("/connect-calender2", {
                      state: { agentId: agent?.agent_id, bussinesId: agent?.businessId },
                    })
                  }
                  style={{ cursor: "pointer" }}
                >
                  <img src="/svg/connect_calendar.svg" alt="connect_calendar" />
                  <p className={styles.TextTest}>Connect</p>
                </div>
              )}

              {hasWeidget ? (
                <div
                  className={styles.TesDiv}
                  onClick={() => {
                    navigate("/Business_hours", {
                      state: {
                        agent_id: agentData?.agent?.agent_id,
                        calendarId: agentData?.agent?.calendarId,
                      },
                    });
                  }}
                  style={{ cursor: "pointer" }}
                  role="button"
                  tabIndex={0}
                >
                  <img
                    src="/svg/agent_schedule_icon.svg"
                    alt="agent_schedule"
                  />
                  <p className={styles.TextTest}>Agent Schedule</p>
                </div>
              ) : (
                <div
                  className={styles.TesDiv}
                  id="tour-widget-install"
                  onClick={() => {
                    navigate("/integrate-agent", {
                      state: {
                        agentDetails: agentData?.agent,
                      },
                    });
                  }}
                  style={{ cursor: "pointer" }}
                  role="button"
                  tabIndex={0}
                >
                  <img src="/svg/widget_install.svg" alt="widget_install" />
                  <p className={styles.TextTest}>Widget install</p>
                </div>
              )}
            </div>
          </LockOverlay>
        </div>
      )}

      <>
        <div className={styles.mainContainer}>
          <Divider label="Your Public Agent URL " />

          <LockOverlay
            locked={publicUrlLocked}
            message={
              driveLocked
                ? driveLockMessage
                : "Upgrade your plan to unlock your public agent URL."
            }
          >
          <div
            id="tour-public-agent-url"
            className={styles.publicUrlContainer}
            onClick={publicUrlLocked ? undefined : handleCopy}
            role="button"
            tabIndex={0}
            onKeyDown={(e) =>
              !publicUrlLocked &&
              (e.key === "Enter" || e.key === " ") &&
              handleCopy()
            }
            style={{ cursor: publicUrlLocked ? "default" : "pointer" }}
          >
            <div className={styles.linkEdit}>
              <h3>{finalUrl}</h3>
              <button
                className={styles.editBtn}
                style={
                  !canEditAgents
                    ? {
                        filter: "blur(2px)",
                        opacity: 0.5,
                        pointerEvents: "none",
                      }
                    : {}
                }
                title={
                  !canEditAgents
                    ? "You don't have edit access"
                    : "Edit Public URL"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  if (!canEditAgents) return;
                  handleCopyPublicLink(agentData?.agent?.agentCode, true);
                }}
              >
                <img src="/svg/edit_black.svg" alt="edit-svg2" />
              </button>
            </div>

            <div className={styles.actions}>
              <div className={styles.copyWrapper}>
                <div
                  className={styles.copyButton}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (publicUrlLocked) return;
                    handleCopy();
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <img src="/svg/copy-icon.svg" alt="Copy" />
                </div>
                {copied && <span className={styles.tooltip}>Copied!</span>}
              </div>
            </div>
          </div>
          </LockOverlay>
          

          <h1 className={styles.Agenttitle}>Call Analytics</h1>

          <div className={styles.agentStats}>
            <LockOverlay locked={!canViewCallLogs}>
              <div
                className={`${styles.stat} ${styles.Yellow}`}
                id="tour-total-calls"
                onClick={handleCallHistoryNavigation}
                style={{ cursor: "pointer" }}
                role="button"
                tabIndex={0}
              >
                <div className={styles.statText}>Total Calls</div>
                <div className={styles.statDetail}>
                  {agentData?.callSummary?.totalCalls || "0"}
                </div>
              </div>
            </LockOverlay>

            <LockOverlay locked={!canViewCallLogs}>
              <div
                className={`${styles.stat} ${styles.blue}`}
                onClick={handleCallHistoryNavigation}
                style={{ cursor: "pointer" }}
                role="button"
                tabIndex={0}
              >
                <span className={styles.statText}>Avg. Call Duration</span>
                <span className={styles.statDetail}>
                  {agentData?.avgCallTime?.minutes ||
                  agentData?.avgCallTime?.seconds ? (
                    <>
                      {agentData?.avgCallTime?.minutes}
                      <span className={styles.MinFont}>m</span>
                      {agentData?.avgCallTime?.seconds}
                      <span className={styles.MinFont}>s</span>
                    </>
                  ) : (
                    <>NA</>
                  )}
                </span>
              </div>
            </LockOverlay>

            <LockOverlay locked={!canViewAppointments}>
              <div
                className={`${styles.stat} ${styles.Purple}`}
                onClick={() => navigate("/calendar")}
                style={{ cursor: "pointer" }}
                role="button"
                tabIndex={0}
              >
                <span className={styles.statText}>Bookings</span>
                <span className={styles.statDetail}>{meetingCount ?? "0"}</span>
              </div>
            </LockOverlay>

            <div className={`${styles.stat} ${styles.Red}`}>
              <span className={styles.statText}>Minutes Remaining</span>
              <span className={styles.statDetail}>
                {agentData?.agent?.mins_left != null
                  ? Math.floor(agentData?.agent?.mins_left / 60)
                  : "0"}
              </span>
            </div>
          </div>
        </div>
      </>

      {openPublicUrlModal && (
        <Modal2 isOpen={openPublicUrlModal} onClose={handleClosePublicWidget}>
          <PublicCopyUrl
            agent={agentData?.agent}
            isRefresh={isRefresh}
            isEditMode={publicUrlEditMode}
          />
        </Modal2>
      )}
      {/* {showPopup && ( */}
      <PopUp
        type={popupType}
        message={popupMessage}
        onClose={() => setPopupMessage("")}
      />
      {/* )} */}
    </>
  );
};

export default AgentCardDetail;
